import { cn } from 'lib/utils';
import { useEffect, useState } from 'react';
import brandbookPreview from './images/book-image.png';
import botPreview from './images/bot-builder.png';
import gifPreview from './images/social-media.png';
import { getDevToolRoute } from 'lib/footer.util';
import useEmblaCarousel from 'embla-carousel-react';

const toolsItems = [
  {
    title: 'Brandbook',
    description:
      "Define and showcase your brand's story with clarity and consistency.",
    image: brandbookPreview,
    showArrow: true,
    buttonColor: '#FF6B6B',
    buttonText: 'New Release',
    toolLink: getDevToolRoute('BRANDBOOK'),
  },
  {
    title: 'GIF Maker',
    description:
      'Create GIFs from any images in seconds with our awesome tool.',
    image: gifPreview,
    showArrow: true,
    buttonColor: '#846CEC',
    buttonText: 'New Release',
    toolLink: getDevToolRoute('GIF_MAKER'),
  },
  {
    title: 'AI Agent',
    description: 'More information - TBA',
    image: botPreview,
    showArrow: false,
    buttonColor: '#846CEC',
    buttonText: 'Upcoming',
  },
];

const MobileCard = ({ item }: { item: (typeof toolsItems)[0] }) => {
  return (
    <div className="flex-[0_0_85%] min-w-0 pl-4 md:pl-0">
      <div className="bg-[#1C1C1C] rounded-2xl overflow-hidden">
        <img
          alt={item.title}
          className="w-full aspect-[1.5] object-cover"
          src={item.image}
        />
        <div className="p-4">
          <div className="flex justify-between items-center mb-3">
            <div
              className={cn(
                'px-3 py-1 rounded-lg text-sm',
                item.buttonColor === '#846CEC'
                  ? 'bg-[#846CEC16] text-[#846CEC]'
                  : 'bg-[#FF6B6B16] text-[#FF6B6B]'
              )}
            >
              {item.buttonText}
            </div>
            {item.showArrow && (
              <div
                className="bg-purple-500 p-2 rounded-lg cursor-pointer hover:shadow-lg"
                onClick={() => window.open(item.toolLink, '_blank')}
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M7 17L17 7M17 7H7M17 7V17"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            )}
          </div>
          <h3 className="text-white text-xl tracking-wider mb-2">
            {item.title}
          </h3>
          <p className="text-text-placeholder text-sm">{item.description}</p>
        </div>
      </div>
    </div>
  );
};

const DesktopCard = ({ item }: { item: (typeof toolsItems)[0] }) => {
  return (
    <div className="bg-background-main rounded-lg p-6 max-w-[368px] flex flex-col">
      <div className="flex justify-between">
        <div className="flex justify-between items-start mb-4 flex-col">
          {item.showArrow && (
            <div
              className="bg-primary p-2 rounded-lg cursor-pointer hover:shadow-lg"
              onClick={() => window.open(item.toolLink, '_blank')}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path
                  d="M7 17L17 7M17 7H7M17 7V17"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          )}
          <div
            className={cn(
              'px-3 py-1 rounded-lg mt-auto',
              item.buttonColor === '#846CEC'
                ? 'bg-[#846CEC16] text-[#846CEC]'
                : 'bg-[#FF6B6B16] text-[#FF6B6B]'
            )}
          >
            <span className="text-sm">{item.buttonText}</span>
          </div>
        </div>
        <img
          alt={item.title}
          className="size-32 object-cover rounded-lg mb-4"
          src={item.image}
        />
      </div>
      <div>
        <h3 className="text-text-primary text-xl tracking-wider mb-4">
          {item.title}
        </h3>
        <p className="text-text-secondary text-sm pr-28">{item.description}</p>
      </div>
    </div>
  );
};

const MobileSlider = () => {
  const [emblaRef] = useEmblaCarousel({
    align: 'start',
    containScroll: 'trimSnaps',
  });

  return (
    <div className="overflow-hidden" ref={emblaRef}>
      <div className="flex">
        {toolsItems.map((item) => (
          <MobileCard key={item.title} item={item} />
        ))}
      </div>
    </div>
  );
};

const UpcomingTools = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return (
    <div className="bg-background-marketing py-10 md:py-14 pb-16 md:pb-32">
      <div className="text-text-primary text-center text-3xl md:text-[42px] tracking-wider font-normal leading-none mb-8 md:mb-12">
        Upcoming tools
      </div>

      {isMobile ? (
        <MobileSlider />
      ) : (
        <div className="flex flex-wrap justify-center gap-6">
          {toolsItems.map((item) => (
            <DesktopCard key={item.title} item={item} />
          ))}
        </div>
      )}
    </div>
  );
};

export default UpcomingTools;
